module.exports = __webpack_public_path__ + "static/img/iconmenu04_white.642078c0.svg";